/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/unbound-method */
import DefaultPageProvider, { defaultStaticQueries } from '@components/DefaultPageProvider'
import BasePageLayout from '@components/layouts/BasePageLayout'
import StoresSalesPageProvider from '@components/layouts/StoresSalesPageProvider'
import MetaTags from '@components/metaTags/MetaTags'
import StoresSaleContextProvider, { TabProps } from '@components/tickets/StoresSaleContext'
import { ProductProps } from '@components/tickets/StoresSaleProductList'
import { addApolloState, ApolloClient, initializeApollo } from '@lib/apolloClient'
import {
  formatCustomProductsList,
  formatListProducts,
  formatSingleDeal,
} from '@lib/utils/formatProducts'
import { COMMERCE_GET_DEAL } from '@ops/queries/CommerceGetDeal'
import { COMMERCE_GET_STORE } from '@ops/queries/CommerceGetStore'
import { COMMERCE_LIST_PRODUCTS } from '@ops/queries/CommerceListProducts'
import { COMMERCE_LIST_SALES } from '@ops/queries/CommerceListSales'
import {
  CommerceSearchTermOp,
  CommerceSortTermDirection,
  CommerceStore,
  Enum_Componentwebelementsproducts_Type as ComponentWebElementsProductsType,
  ListProductsQuery,
  ListSalesQuery,
  StoresTicketApplicationsPageLayoutFragment,
  StoresTicketInfoPanelFragment,
  StoresTicketSalesPageLayoutFragment,
  TabularMenuFragment,
} from '@ts/operations'
import { GetStaticPaths } from 'next'
import { ParsedUrlQuery } from 'querystring'
import React from 'react'
import ErrorPage from 'src/pages/_error'

interface SalesPageProps {
  categoriesMenu: TabularMenuFragment
  initialPath: string
  store: CommerceStore
  tabs: Array<TabProps>
}

const TICKET_PAGES_PATHS = [
  'attendees',
  'premium',
  'group-offers',
  'partners',
  'investors',
  'startups',
]

const BookTicketsPage = ({ categoriesMenu, initialPath, store, tabs }: SalesPageProps) => {
  if (!tabs?.length) return <ErrorPage statusCode={404} />
  const defaultTabIndex = tabs?.findIndex(tab => tab?.path === initialPath)
  return (
    <DefaultPageProvider>
      <BasePageLayout
        title={
          tabs?.[defaultTabIndex]?.webPage?.seoTags?.title ||
          tabs?.[defaultTabIndex]?.webPage?.title
        }
      >
        <MetaTags
          seoTags={tabs?.[defaultTabIndex]?.webPage?.seoTags ?? undefined}
          title={
            tabs?.[defaultTabIndex]?.webPage?.seoTags?.title ||
            tabs?.[defaultTabIndex]?.webPage?.title
          }
        />
        <StoresSaleContextProvider
          categoriesMenu={categoriesMenu}
          defaultTabIndex={defaultTabIndex}
          store={store}
          tabs={tabs}
        >
          <StoresSalesPageProvider />
        </StoresSaleContextProvider>
      </BasePageLayout>
    </DefaultPageProvider>
  )
}

export default BookTicketsPage

export const getStaticPaths: GetStaticPaths<{ slug: string }> = async () => {
  return Promise.resolve({
    fallback: true,
    paths: TICKET_PAGES_PATHS.map(item => ({ params: { slug: item } })),
  })
}

const getSalesCycles = async (apollo: ApolloClient, productId?: string) => {
  if (!productId) {
    return []
  }

  let salesCycles
  const query = () =>
    apollo.query({
      context: {
        slug: process.env.DEFAULT_CONFERENCE_SLUG as string,
      },
      fetchPolicy: 'no-cache',
      query: COMMERCE_LIST_SALES,
      variables: {
        sort: [{ direction: CommerceSortTermDirection.Asc, field: 'endDate' }],
        terms: [
          {
            field: 'saleProducts.product.id',
            op: CommerceSearchTermOp.Eq,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            value: productId,
          },
        ],
      },
    })
  salesCycles = await query()

  if (salesCycles?.data?.commerceListSales === null) salesCycles = await query()
  const salesContent: ListSalesQuery = salesCycles?.data
  return salesContent?.commerceListSales?.content || []
}
type GetProductsListArgs = {
  apollo: ApolloClient
  productIds: string[]
  products?: StoresTicketSalesPageLayoutFragment['products']
  store: Pick<CommerceStore, 'slug' | 'id' | 'currency' | 'currencySymbol' | 'country'>
}
const getProductsList = async ({
  apollo,
  products = [],
  productIds = [],
  store,
}: GetProductsListArgs) => {
  if (productIds.length <= 0) {
    return []
  }

  let productsQuery
  const query = () =>
    apollo.query({
      context: {
        slug: process.env.DEFAULT_CONFERENCE_SLUG as string,
      },
      fetchPolicy: 'no-cache',
      query: COMMERCE_LIST_PRODUCTS,
      variables: {
        terms: [{ field: 'id', op: CommerceSearchTermOp.Eq, value: productIds }],
      },
    })
  productsQuery = await query()
  if (productsQuery?.data?.commerceListProducts === null) productsQuery = await query()
  const productsList = productsQuery?.data
    ?.commerceListProducts as ListProductsQuery['commerceListProducts']
  const result = productsList?.content?.map(a => {
    const currentProduct = products.find(b => b.product?.sourceId === a.id)
    return {
      ...a,
      ...currentProduct,
      id: currentProduct?.id,
      name: currentProduct?.product?.title || currentProduct?.product?.sourceName || a.name,
      productId: a.id || currentProduct?.product?.sourceId,
    }
  })

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return formatListProducts(result, store)
}
type GetSingleProductArgs = {
  apollo: ApolloClient
  benefits?: null | StoresTicketSalesPageLayoutFragment['benefits']
  product?: StoresTicketInfoPanelFragment['product']
  productId: string
  store: Pick<CommerceStore, 'slug' | 'id' | 'currency' | 'currencySymbol' | 'country'>
}
const getSingleProduct = async ({
  apollo,
  benefits,
  product,
  productId,
  store,
}: GetSingleProductArgs) => {
  if (!productId) {
    return []
  }

  let productsQuery
  const query = () =>
    apollo.query({
      context: {
        slug: process.env.DEFAULT_CONFERENCE_SLUG as string,
      },
      fetchPolicy: 'no-cache',
      query: COMMERCE_LIST_PRODUCTS,
      variables: {
        terms: [{ field: 'id', op: CommerceSearchTermOp.Eq, value: productId }],
      },
    })
  productsQuery = await query()
  if (productsQuery?.data?.commerceListProducts === null) productsQuery = await query()
  const productsList = productsQuery?.data
    ?.commerceListProducts as ListProductsQuery['commerceListProducts']
  const result = productsList?.content?.map(a => {
    return {
      ...a,
      ...product,
      benefits: benefits?.map(b => b.benefit) || null,
      id: product?.id,
      name: product?.title || product?.sourceName || a.name,
      productId: a.id || product?.sourceId,
      type: ComponentWebElementsProductsType.Sale,
    }
  })

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return formatListProducts(result, store)
}
type GetSingleDealArgs = {
  apollo: ApolloClient
  dealId: string
  store: Pick<CommerceStore, 'slug' | 'id' | 'currency' | 'currencySymbol' | 'country'>
}
const getSingleDeal = async ({ dealId, apollo, store }: GetSingleDealArgs) => {
  if (!dealId) return null

  let dealsQuery
  const query = () =>
    apollo.query({
      context: {
        slug: process.env.DEFAULT_CONFERENCE_SLUG as string,
      },
      fetchPolicy: 'no-cache',
      query: COMMERCE_GET_DEAL,
      variables: {
        id: dealId,
      },
    })
  dealsQuery = await query()

  if (dealsQuery?.data?.commerceGetDeal === null) dealsQuery = await query()
  const commDeal = dealsQuery?.data?.commerceGetDeal
  const deal = {
    ...commDeal,
    dealId: commDeal.id,
    product: commDeal.dealItems?.[0]?.product,
    productId: commDeal.dealItems?.[0]?.product?.id,
    type: 'sale' as ComponentWebElementsProductsType.Sale,
  }

  return formatSingleDeal(deal, store) || null
}

type GetDealsListArgs = {
  apollo: ApolloClient
  dealIds: string[]
  products?: StoresTicketSalesPageLayoutFragment['products']
  store: Pick<CommerceStore, 'slug' | 'id' | 'currency' | 'currencySymbol' | 'country'>
}
type ShortDealType = {
  dealItems?: Array<{ product?: { id?: string } }>
  description?: string
  id?: string
  name?: string
} | null
const getDealsList = async ({ products, dealIds, apollo, store }: GetDealsListArgs) => {
  if (dealIds?.length > 0) {
    const dealsQuery = await Promise.all(
      dealIds.map(async d => {
        const getDeal = await getSingleDeal({ apollo, dealId: d, store })
        return getDeal
      })
    )

    if (dealsQuery.length > 0) {
      const result = dealsQuery?.map(a => {
        if (!a) return null
        const shortDeal = a as ShortDealType
        const currentProduct = products?.find(b => b.product?.sourceId === shortDeal?.id)
        return {
          ...a,
          ...currentProduct,
          description: currentProduct?.product?.description || shortDeal?.description,
          name:
            currentProduct?.product?.title ||
            currentProduct?.product?.sourceName ||
            shortDeal?.name,
          tags:
            currentProduct?.benefits?.map(tag => {
              return {
                code: tag.id || '',
                description: tag.description || '',
                id: tag.id || '',
                name: tag.title || '',
              }
            }) || null,
        }
      })

      return result || []
    }
    return []
  }

  return []
}

const getPage = async (
  apollo: ApolloClient,
  path: string,
  store: Pick<CommerceStore, 'slug' | 'id' | 'currency' | 'currencySymbol' | 'country'>
) => {
  const { webPage } = await defaultStaticQueries(apollo, path)
  const page = webPage.webPageByHostPath?.content.find(
    item =>
      item?.__typename === 'ComponentWebLayoutsStoresTicketSalesPage' ||
      item?.__typename === 'ComponentWebLayoutsStoresTicketApplicationsPage'
  ) as StoresTicketSalesPageLayoutFragment | StoresTicketApplicationsPageLayoutFragment
  const categoriesMenu: TabularMenuFragment | null = page?.categoriesMenu
  const countdownTimer =
    page?.priceIncreaseCountdownTimer?.product?.sourceId &&
    (await getSalesCycles(apollo, page?.priceIncreaseCountdownTimer?.product?.sourceId))
  const releasePhaseStepper =
    page?.releasePhaseStepper?.product?.sourceId &&
    (await getSalesCycles(apollo, page?.releasePhaseStepper?.product?.sourceId))
  let products
  if (page) {
    if (page.__typename === 'ComponentWebLayoutsStoresTicketSalesPage') {
      const productsList = page?.products?.filter(item => item?.product?.type === 'product')
      const productsListIds = productsList?.map(item => item?.product?.sourceId || '')
      const customProductsList = page?.products?.filter(item => item?.product?.type === 'custom')
      const dealsList = page?.products?.filter(item => item?.product?.type === 'deal')
      const dealsListIds = dealsList?.map(item => item?.product?.sourceId || '')
      const pageProductIds = page?.products || []

      const customProductsData = formatCustomProductsList({
        currencySymbol: store.currencySymbol || '',
        products: customProductsList,
      })
      const productsData = await getProductsList({
        apollo,
        productIds: productsListIds,
        products: productsList,
        store,
      })

      const dealsData = await getDealsList({
        apollo,
        dealIds: dealsListIds,
        products: dealsList,
        store,
      })

      const dealsDataWithCode = (dealsData || []).map(deal => ({
        ...deal,
        code: dealsList.find(p => p.product?.sourceId === deal?.dealId)?.product?.code,
      })) as ProductProps[]

      products = [...customProductsData, ...productsData, ...dealsDataWithCode].sort((a, b) => {
        return (
          pageProductIds.map(e => e?.id).indexOf(a?.id || '') -
          pageProductIds.map(e => e?.id).indexOf(b?.id || '')
        )
      })
      if (productsList.length && !products.length) {
        throw new Error(`Unable to fetch products/deals on ${path} page in "getPage" function`)
      }
    }
    if (page.__typename === 'ComponentWebLayoutsStoresTicketApplicationsPage') {
      const product = page?.ticketInfoPanel?.product
      const pageProductIds = [product]

      const customProductsData =
        product?.type === 'custom'
          ? formatCustomProductsList({
              currencySymbol: store.currencySymbol || '',
              products: [{ benefits: page?.benefits?.map(item => item.benefit), product }],
            })
          : []
      const productData =
        product?.type === 'product' || product?.type === 'package'
          ? await getSingleProduct({
              apollo,
              benefits: page?.benefits,
              product,
              productId: product?.sourceId || '',
              store,
            })
          : []

      const dealData =
        product?.type === 'deal' && product?.sourceId
          ? [
              await getSingleDeal({
                apollo,
                dealId: product.sourceId,
                store,
              }),
            ]
          : []

      products = [...customProductsData, ...productData, ...dealData].sort((a, b) => {
        const typeFixA = a as { id?: string }
        const typeFixB = b as { id?: string }
        return (
          pageProductIds.map(e => e?.id).indexOf(typeFixA?.id || '') -
          pageProductIds.map(e => e?.id).indexOf(typeFixB?.id || '')
        )
      })
      if (product && !products.length) {
        throw new Error(`Unable to fetch products/deals on ${path} page in "getPage" function`)
      }
    }
    if (page?.priceIncreaseCountdownTimer?.product?.sourceId && !countdownTimer) {
      throw new Error(`Unable to fetch countdownTimer on ${path} page in "getPage" function`)
    }
    if (page?.releasePhaseStepper?.product?.sourceId && !releasePhaseStepper) {
      throw new Error(`Unable to fetch sale cycles on ${path} page in "getPage" function`)
    }

    return {
      benefitsList: page?.benefits?.map(item => item.benefit) || null,
      categoriesMenu: categoriesMenu || null,
      countdownTimer: countdownTimer || null,
      path,
      products,
      releasePhaseStepper: releasePhaseStepper || null,
      webPage: webPage.webPageByHostPath,
    }
  }
  return null
}

interface Params extends ParsedUrlQuery {
  slug: string
}

export const getStaticProps = async ({ params }: { params: Params }) => {
  const currentSlug = params?.slug
  const apollo = initializeApollo()
  let storeQuery
  const query = () =>
    apollo.query({
      context: {
        slug: process.env.DEFAULT_CONFERENCE_SLUG as string,
      },
      fetchPolicy: 'no-cache',
      query: COMMERCE_GET_STORE,
    })
  storeQuery = await query()

  if (storeQuery?.data?.commerceGetStore === null) storeQuery = await query()

  const brokenPageConfig = {
    props: { slug: process.env.DEFAULT_CONFERENCE_SLUG, store: storeQuery },
    revalidate: 1,
  }
  const store = storeQuery?.data?.commerceGetStore
  if (store) {
    const tabs = await Promise.all(
      TICKET_PAGES_PATHS.map(item => getPage(apollo, `/tickets/${item}`, store))
    )
    const filteredTabs = tabs.filter(i => i !== null)
    if (!filteredTabs.length) return brokenPageConfig
    const categoryTab = filteredTabs.find(
      tab => tab?.categoriesMenu && tab?.categoriesMenu?.menuItems?.length > 0
    )
    const categoriesMenu: TabularMenuFragment | null | undefined = categoryTab?.categoriesMenu
    const categoriesMenuItems = [...(categoriesMenu?.menuItems || [])]
    const sortedCategoriesMenuItems = categoriesMenuItems?.sort((a, b) => {
      let A = ''
      let B = ''
      if (a && a.link.__typename === 'ComponentWebLinksPageLink') {
        A = a.link?.page?.path || ''
      } else if (a && a.link.__typename === 'ComponentWebLinksUrlLink') {
        A = a.link?.url || ''
      }
      if (b && b.link.__typename === 'ComponentWebLinksPageLink') {
        B = b.link?.page?.path || ''
      } else if (b && b.link.__typename === 'ComponentWebLinksUrlLink') {
        B = b.link?.url || ''
      }
      if (
        TICKET_PAGES_PATHS.indexOf(A.replace('/tickets/', '')) >
        TICKET_PAGES_PATHS.indexOf(B.replace('/tickets/', ''))
      ) {
        return 1
      }
      return -1
    })

    const props = {
      categoriesMenu:
        sortedCategoriesMenuItems && sortedCategoriesMenuItems.length > 0
          ? { menuItems: sortedCategoriesMenuItems }
          : null,
      initialPath: `/tickets/${currentSlug || ''}`,
      slug: process.env.DEFAULT_CONFERENCE_SLUG,
      store,
      tabs: filteredTabs,
    }

    return addApolloState<typeof props>(apollo, {
      props,
      revalidate: false,
    })
  }

  return brokenPageConfig
}
